import { render, staticRenderFns } from "./CommunityContacts.vue?vue&type=template&id=743f7c58&"
import script from "./CommunityContacts.vue?vue&type=script&lang=ts&"
export * from "./CommunityContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports